/**
 * Facebook Pixel utility functions
 */

/**
 * Initialize Facebook Pixel with the given ID
 * @param {string} pixelId - The Facebook Pixel ID to use
 * @returns {boolean} - Whether initialization was successful
 */
export const initializePixel = (pixelId) => {
  try {
    // const trackSimpleConfig = document.createElement('script');
    // trackSimpleConfig.innerHTML = `
    //     fb_pixel_id = '${pixelId}';
    //     handl_custom_params = ['utm_partner'];
    //     var handl_js = document.createElement("script");
    //     handl_js.setAttribute("src", "https://track.utmsimple.com/utm.js?license=7d4856e0322e11eca0d731cb18926450");
    //     document.head.appendChild(handl_js);
    //   `;
    // document.head.appendChild(trackSimpleConfig);
    console.log('Meta Pixel loaded');
    return true;
  } catch (error) {
    console.error('Error initializing Meta Pixel:', error);
    return false;
  }
};
